import { render, staticRenderFns } from "./RegionsCarbonTable.vue?vue&type=template&id=0d9964de&scoped=true&"
import script from "./RegionsCarbonTable.vue?vue&type=script&lang=ts&"
export * from "./RegionsCarbonTable.vue?vue&type=script&lang=ts&"
import style0 from "./RegionsCarbonTable.vue?vue&type=style&index=0&id=0d9964de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9964de",
  null
  
)

/* custom blocks */
import block0 from "./RegionsCarbonTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports